var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import "./style/style.css";
import "./App.css";
import { MainView } from "./views/main-view/MainView.component";
import { useEffect, useRef, useState } from "react";
import { SessionView } from "./views/session-view/SessionView.component";
import { createRoot } from "react-dom/client";
import { Toast } from "./components/toast/Toast.component";
import { ErrorDialog } from "./dialogs/error-dialog/ErrorDialog.component";
import { initializeAvatarConfigStore } from "./store/avatar-config.store";
import { ConfirmDialog } from "./dialogs/confirm-dialog/ConfirmDialog.component";
import { busServiceMain } from "../modules/bus";
import { AskOkMessage, RequestUserConfirmationRequestMessage } from "flavr-common";
import { MessageService } from "./services/message.service";
import { HTMLTooltip } from "./components/html-tooltip/HTMLTooltip.component";
import { supportedLanguages } from "../../i18n";
import { preferencesService } from "../modules/preferences/PreferencesService";
import { SetRaycastSettingsMessage } from "../messages/selection/SelectionStrategyMessages";
import { useTranslation } from "react-i18next";
import { renderManager } from "../modules/xr/RenderManager";
import { StartTrainingDialog } from "./dialogs/training-dialog/start-training-dialog/StartTrainingDialog.component";
import { EndTrainingDialog } from "./dialogs/training-dialog/end-training-dialog/EndTrainingDialog.component";
// TODO: Move global state and current session to a global store
var GlobalAppState;
(function (GlobalAppState) {
    GlobalAppState[GlobalAppState["loading"] = 0] = "loading";
    GlobalAppState[GlobalAppState["ready"] = 1] = "ready";
})(GlobalAppState || (GlobalAppState = {}));
const globalAppState = GlobalAppState.ready;
const busConnection = busServiceMain.connection("App");
export function App() {
    const [currentSession, setCurrentSession] = useState(undefined); // TODO: Replace
    const appRootElement = useRef(document.getElementById("app-root"));
    const { t, i18n } = useTranslation();
    const updateLanguage = () => {
        let lng = preferencesService.getPreferredValue("displayLanguage", "");
        if (lng === "") {
            lng = navigator.language.split("-")[0];
        }
        if (!supportedLanguages.find((l) => l === lng)) {
            lng = "en";
        }
        void i18n.changeLanguage(lng);
    };
    const updateRaycastSettings = () => {
        var _a, _b;
        busConnection.send(new SetRaycastSettingsMessage((_a = preferencesService.getBooleanPreferredValue("raycastEnabled", true)) !== null && _a !== void 0 ? _a : true, (_b = preferencesService.getBooleanPreferredValue("raycastVisualizationEnabled", true)) !== null && _b !== void 0 ? _b : true));
    };
    useEffect(() => {
        preferencesService.onPreferenceChanged.add((key) => __awaiter(this, void 0, void 0, function* () {
            if (key === "displayLanguage") {
                updateLanguage();
                return true;
            }
            if (key === "raycastEnabled" || key === "raycastVisualizationEnabled") {
                updateRaycastSettings();
                return true;
            }
            return false;
        }));
        updateLanguage();
        updateRaycastSettings();
        const userName = localStorage.getItem("username");
        if (userName) {
            setCurrentSession(!!window.location.search);
        }
        initializeAvatarConfigStore();
        busConnection.subscribeForAskRequest(RequestUserConfirmationRequestMessage, handleRequestUserConfirmationRequestMessage);
    }, []);
    useEffect(() => {
        if (appRootElement.current) {
            if (currentSession) {
                appRootElement.current.classList.add("no-pointer-events");
            }
            else {
                appRootElement.current.classList.remove("no-pointer-events");
            }
        }
    }, [currentSession]);
    // TODO: If this can only be a delete message, rename RequestUserConfirmationRequestMessage to DeleteUserConfirmationRequestMessage (or similar)
    // if not, find a way to differentiate between the two and the use MessageService.showConfirmationDelete instead of MessageService.showConfirmationOkCancel
    const handleRequestUserConfirmationRequestMessage = (msg, askId) => __awaiter(this, void 0, void 0, function* () {
        // Automatically decline ask message in XR mode as we have no way to display a dialog in XR at this point. If we
        // have a proper dialog in XR at some point we can get rid of this part
        if (renderManager.isXRPresenting()) {
            busConnection.answer(askId, new AskOkMessage(false));
            return;
        }
        yield MessageService.showConfirmationOkCancel(msg.popupText, () => {
            busConnection.answer(askId, new AskOkMessage(true));
        }, () => {
            busConnection.answer(askId, new AskOkMessage(false));
        });
    });
    return (React.createElement(React.Fragment, null,
        globalAppState === GlobalAppState.loading && React.createElement("div", { className: "app-loading" }, t("common:loading-text", "Loading...")),
        globalAppState === GlobalAppState.ready && currentSession && React.createElement(SessionView, null),
        globalAppState === GlobalAppState.ready && !currentSession && React.createElement(MainView, null),
        React.createElement("div", { className: "app-message-container" },
            React.createElement(Toast, null),
            React.createElement(ErrorDialog, null),
            React.createElement(ConfirmDialog, null),
            React.createElement(StartTrainingDialog, null),
            React.createElement(EndTrainingDialog, null)),
        React.createElement(HTMLTooltip, null)));
}
export function initializeApp() {
    const appRoot = document.getElementById("app-root");
    if (appRoot) {
        createRoot(appRoot).render(React.createElement(App, null));
    }
    else {
        console.error("Could not find app-root element");
    }
}
